/* Slice for development tools/helps */

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface DevState {
    showDebugPanel: boolean
    showReferences: boolean
    showAltSaveConfiguration: boolean
    cantCallPricingMotive: string
    billingRequest: any
}

const initialState: DevState = {
    showDebugPanel: import.meta.env.MODE === 'development' ? true : false,
    showReferences: false,
    showAltSaveConfiguration: import.meta.env.MODE === 'development' ? true : false,
    cantCallPricingMotive: '',
    billingRequest: null
};

export const devSlice = createSlice({
    name: 'dev',
    initialState,
    reducers: {
        toggleDebugPanel: (state) => {
            state.showDebugPanel = !state.showDebugPanel;
        },
        toggleShowReferences: (state) => {
            state.showReferences = !state.showReferences;
        },
        setShowAltSaveConfiguration: (state, action: PayloadAction<boolean>) => {
            state.showAltSaveConfiguration = action.payload;
        },
        setPricingInfo: (state, action: PayloadAction<{billingRequest: any, cantCallMotive: string}>) => {
            state.cantCallPricingMotive = action.payload.cantCallMotive;
            state.billingRequest = action.payload.billingRequest;
        }
    }
});

export const devActions = devSlice.actions;

export default devSlice.reducer;


// ==== selectors ====

export const showDebugSelector = (state: { dev: DevState }) => state.dev.showDebugPanel;
export const cantCallPricingMotiveSelector = (state: { dev: DevState }) => state.dev.cantCallPricingMotive;
export const altSaveConfigurationSelector = (state: { dev: DevState }) => state.dev.showAltSaveConfiguration;
